import { defineComponent as p, ref as y, computed as t, resolveComponent as f, openBlock as a, createElementBlock as C, normalizeClass as b, createElementVNode as k, createBlock as n, createCommentVNode as l, withKeys as S, renderSlot as v } from "vue";
import { _ as B } from "./VHeadline.vue_vue_type_script_lang-186a5340.js";
import V from "./components/atoms/VIconButton/VIconButton.js";
import { getComputedStyleValue as i } from "./utils/getComputedStyleValue.js";
import { _ as $ } from "./_plugin-vue_export-helper-dad06003.js";
var o = /* @__PURE__ */ ((e) => (e.DARK = "DARK", e.LIGHT = "LIGHT", e))(o || {});
const H = p({
  name: "VDrawer",
  components: {
    VHeadline: B,
    VIconButton: V
  },
  props: {
    /**
     * title at top of the drawer
     */
    title: {
      type: String
    },
    /**
     * flag telling if the header of the drawer is visible
     */
    showHeader: {
      type: Boolean,
      default: !0
    },
    /**
     * flag telling if the back button is visible
     */
    showBack: {
      type: Boolean,
      default: !1
    },
    /**
     * flag telling if the close button is visible
     */
    showClose: {
      type: Boolean,
      default: !0
    },
    /**
     * Defines the color style of title, back and close button
     */
    headerColorStyle: {
      type: String,
      default: o.DARK
    },
    isScrolled: {
      type: Boolean,
      default: !1
    },
    headerClass: {
      type: String,
      default: ""
    },
    backAriaLabel: {
      type: String,
      default: "Back"
    },
    closeAriaLabel: {
      type: String,
      default: "Close"
    }
  },
  emits: ["drawer-header:close", "drawer-header:back"],
  data() {
    return {
      ColorMode: o
    };
  },
  setup(e) {
    const r = y(!1);
    window.matchMedia("(max-width: 415px)").addEventListener("change", (h) => {
      r.value = h.matches;
    });
    const d = t(
      () => !r.value && !e.isScrolled ? "s" : "xs"
    ), s = t(() => e.headerColorStyle === o.DARK ? i("--hobi-color-grey-900") : e.headerColorStyle === o.LIGHT ? i("--hobi-color-white") : i("--hobi-color-grey-900")), c = t(() => e.headerColorStyle === o.DARK ? "dark" : e.headerColorStyle === o.LIGHT ? "white" : "dark");
    return {
      headlineFontSize: d,
      buttonColor: s,
      headlineColor: c
    };
  }
});
const g = { class: "hobi-drawer-header hobi-drawer-header__animation" };
function _(e, r, d, s, c, h) {
  const u = f("VIconButton"), w = f("VHeadline");
  return e.showHeader ? (a(), C("div", {
    key: 0,
    class: b(["hobi-drawer-header-container", e.headerClass])
  }, [
    k("div", g, [
      e.showBack ? (a(), n(u, {
        key: 0,
        symbol: "chevron-left",
        size: "24",
        color: e.buttonColor,
        class: "hobi-drawer-back",
        onClick: r[0] || (r[0] = (m) => e.$emit("drawer-header:back")),
        "aria-label": e.backAriaLabel
      }, null, 8, ["color", "aria-label"])) : l("", !0),
      e.title ? (a(), n(w, {
        key: 1,
        id: "hobi-drawer-header__headline",
        size: e.headlineFontSize,
        center: !0,
        title: e.title,
        class: b(["hobi-drawer-headline", e.isScrolled ? "hobi-drawer-headline--scrolled" : ""]),
        color: e.headlineColor
      }, null, 8, ["size", "title", "class", "color"])) : l("", !0),
      e.showClose ? (a(), n(u, {
        key: 2,
        symbol: "close",
        size: "24",
        color: e.buttonColor,
        class: "hobi-drawer-close",
        onClick: r[1] || (r[1] = (m) => e.$emit("drawer-header:close")),
        onKeydown: r[2] || (r[2] = S((m) => e.$emit("drawer-header:close"), ["enter"])),
        "aria-label": e.closeAriaLabel
      }, null, 8, ["color", "aria-label"])) : l("", !0),
      v(e.$slots, "header-extension", {}, void 0, !0)
    ])
  ], 2)) : l("", !0);
}
const K = /* @__PURE__ */ $(H, [["render", _], ["__scopeId", "data-v-733dff71"]]);
export {
  o as C,
  K as V
};
